{
  "genericWords": [
    "^(barn|bazaa?r|bench|bou?tique|building|casa|church)$",
    "^(baseball|basketball|football|soccer|softball|tennis(halle)?)\\s?(field|court)?$",
    "^(club|green|out|ware)\\s?house$",
    "^(driveway|el árbol|fountain|generic|golf|government|graveyard)$",
    "^(fixme|n\\s?\\/?\\s?a|name|no\\s?name|none|null|temporary|test|unknown)$",
    "^(hofladen|librairie|magazine?|maison)$",
    "^(mobile home|skate)?\\s?park$",
    "^(obuwie|pond|pool|sale|shops?|sklep|stores?)$",
    "^\\?+$",
    "^private$",
    "^tattoo( studio)?$",
    "^windmill$",
    "^церковная( лавка)?$"
  ]
}
